import { Component } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { LandingPage } from '../../pages/landing/landing';
import { AuthProvider } from '../../providers/auth/auth'
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LandingPage_PATH } from '../../app/app-constants';
import { RefdataProvider } from '../../providers/refdata/refdata';

//import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook';

/**
 * Generated class for the AuthPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-auth',
  templateUrl: 'auth.html',
  styleUrls: ['./auth.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
    CommonModule,
    FormsModule
  ]
})
export class AuthPage {
  public static PATH: string = 'auth';

  constructor(
    public router: Router, 
    /*, private fb: Facebook*/
    /*private userData: UserDataProvider,*/
    private auth: AuthProvider,
    private refdataProvider: RefdataProvider,
    private plt: Platform
  ) { }

  ionViewCanLoad() {
    return true;
  }

  ionViewDidEnter() {
    console.log('AuthPage: called ionViewDidEnter');
    this.auth.logout().then(() => {
        //redirect to HomeController (after a few seconds?)
        console.log('AuthPage.ionViewDidEnter: going to LandingPage');
        this.router.navigate([ LandingPage_PATH ], { state: { data: {
            animate: true, direction: 'forward'
          }}});
    });
  }

  ngOnInit() {
    console.log('AuthPage: called ngOnInit');
    let platforms: string[] = this.plt.platforms();
//    alert('AuthPage: platforms are: ' + platforms.join());
//    alert('User-Agent = ' + window.navigator.userAgent);
    let userAgent: string = window.navigator.userAgent;

    this.auth.logout().then(() => {
    //redirect to HomeController (after a few seconds?)
    console.log('ionviewWillLoad: going to HomePage');
    if ((this.refdataProvider.isIOS()) && this.plt.testUserAgent("Beerhive")) {
      let dummyRedirectUrl = "beerhiveprotocol://logout?ua=" + userAgent + "&plt=" + platforms + "&src=page";
      console.log('AuthPage: running in app: redirecting to dummy URL ' + dummyRedirectUrl + ' to be intercepted by ios app');
      console.log('AuthPage: ionviewWillLoad: going to ' + dummyRedirectUrl);
//      this.navCtrl.setRoot(LandingPage, {}, {animate: true, direction: 'forward'}).then(() => {
        window.location.href = dummyRedirectUrl;
//      });
      
      console.log('AuthPage: running on ios: redirected to dummy URL ' + dummyRedirectUrl + ' to be intercepted by ios app');
    }
    else {
      console.log('AuthPage: ionviewWillLoad: going to Landing Page');
        this.router.navigate([ LandingPage_PATH ], { state: { data: {
            animate: true, direction: 'forward'
          }}});
    }
    });
  }

}
